import { useQuery } from "@tanstack/react-query";
import { TiCardQueryResponse } from "../../../@types";
import api from "../../../api";

const ONE_DAY_CACHE_TIME = 24 * 60 * 60 * 1000;

const useGetTiCardData = (family?: string) => {
  const { data, isLoading } = useQuery<TiCardQueryResponse>({
    queryKey: ["tiCardGet", family],
    queryFn: () => api.getTiCardData(family ?? "").then(r => r.data),
    enabled: !!family,
    refetchOnWindowFocus: false,
    gcTime: ONE_DAY_CACHE_TIME
  });

  return { data, isLoading };
};

export default useGetTiCardData;
